/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { PagingAndSortingRequestParam } from './PagingAndSortingRequestParam';
import type { VaccineFilter } from './VaccineFilter';

export type VaccineViewRequest = {
    filter?: VaccineFilter;
    pagingAndSortingRequestParam?: PagingAndSortingRequestParam;
    exposeType?: VaccineViewRequest.exposeType;
}

export namespace VaccineViewRequest {

    export enum exposeType {
        EXCEL = 'EXCEL',
        PDF = 'PDF',
        WORD = 'WORD',
        HTML = 'HTML',
        XML = 'XML',
        JSON = 'JSON',
        CSV = 'CSV',
    }


}
